import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div style={styles.container} className='pb-120 pt-120'>
            <h1 style={styles.header}>404</h1>
            <p style={styles.message}>Page Not Found</p>
            <Link to="/" style={styles.link}>Go Back to Home</Link>
        </div>
    );
};

const styles = {
    container: {
        textAlign: 'center',
        marginTop: '50px',
        fontFamily: 'Arial, sans-serif',
    },
    header: {
        fontSize: '72px',
        color: '#b68834',
    },
    message: {
        fontSize: '24px',
        color: '#333',
    },
    link: {
        fontSize: '18px',
        color: '#007bff',
        textDecoration: 'none',
    },
};

export default NotFound;